import { Alert, Button } from "react-bootstrap"
import BadgeEstados from "../../BadgeEstado"
import { getActaDetalleHandler } from "../../../handlers/actaDetalle.handler"
import DoDisturbAltIcon from '@mui/icons-material/DoDisturbAlt';
import { useGeneralAppStore } from "../../../store/generalAppStore";
import { PrinterCheckIcon } from "../../Icons";
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import PersonIcon from '@mui/icons-material/Person';

const Aprobada = ({ aPrev, aPos, amp, amt, acta, actasAImprimir }) => {

    const { handlerModal } = useGeneralAppStore();


    return (
        <div>
            {
                aPos?.some(acta => acta?.estado_id == 8)
                    ?
                    <Alert variant="danger" className="d-flex flex-column gap-2 align-items-center">
                        <div className="bg-white d-flex flex-column align-items-center gap-3 p-2 py-4 border rounded shadow-lg w-100">
                            <div className="d-flex flex-column align-items-center gap-1">
                                <b className="text-center">Se detectaron actas posteriores en <BadgeEstados estado_id={8} /></b>
                                <p className="m-0">Anule el envio marcandolas sin entregar</p>
                                <div className="d-flex gap-2 justify-content-center align-items-center flex-wrap">
                                    {
                                        aPos?.filter(acta => acta?.estado_id == 8).map((a, index) => {
                                            return (
                                                <div key={index}
                                                    className={`bg-warning px-2 rounded  text-white fw-bold `}
                                                    style={{ cursor: index == 0 ? "pointer" : "default" }}
                                                    onClick={() => {
                                                        if (index == 0) {
                                                            getActaDetalleHandler({ estado_id: a?.estado_id, id: a?.id })
                                                        }
                                                    }}
                                                >
                                                    <p className="m-0 text-dark">Acta - {a?.numero_acta}</p>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                            <Button variant="danger" size="sm" className="d-flex gap-1 align-items-center" onClick={() => { handlerModal({ modal: true, modalName: "actas_sin_entregar" }) }}><DoDisturbAltIcon /> Anular envio</Button>
                        </div>
                    </Alert>
                    :
                    aPrev?.some(acta => [3, 7].includes(acta?.estado_id))
                        ?
                        <Alert variant="danger" className="d-flex flex-column gap-2 align-items-center">
                            <div className="bg-white d-flex flex-column align-items-center gap-1 p-2 py-4 border rounded shadow-lg w-100">
                                <b className="text-center">Se detectaron actas con estados previos</b>
                                {
                                    aPrev?.some(acta => acta?.estado_id == 3)
                                    &&
                                    <div className="border w-100 d-flex flex-column align-items-center gap-2 justify-content-center py-2">

                                        <BadgeEstados estado_id={3} />
                                        <div className="d-flex justify-content-center gap-2 flex-wrap align-items-center">
                                            {
                                                aPrev?.filter(acta => acta?.estado_id == 3).map((a, index) => {
                                                    return (
                                                        <div key={index}
                                                            className={`bg-secondary px-2 rounded  text-white fw-bold `}
                                                            style={{ cursor: index == 0 ? "pointer" : "default" }}
                                                            onClick={() => {
                                                                if (index == 0) {
                                                                    getActaDetalleHandler({ estado_id: a?.estado_id, id: a?.id })
                                                                }
                                                            }}
                                                        >
                                                            <p className="m-0">Acta - {a?.numero_acta}</p>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                }
                                {
                                    aPrev?.some(acta => acta?.estado_id == 7)
                                    &&
                                    <div className="border w-100 d-flex flex-column align-items-center gap-2 justify-content-center py-2">

                                        <BadgeEstados estado_id={7} />
                                        <div className="d-flex gap-2 flex-wrap justify-content-center align-items-center">
                                            {
                                                aPrev?.filter(acta => acta?.estado_id == 7).map((a, index) => {
                                                    return (
                                                        <div key={index}
                                                            className={`bg-danger px-2 rounded  text-white fw-bold `}
                                                            style={{ cursor: index == 0 ? "pointer" : "default" }}
                                                            onClick={() => {
                                                                if (index == 0) {
                                                                    getActaDetalleHandler({ estado_id: a?.estado_id, id: a?.id })
                                                                }
                                                            }}
                                                        >
                                                            <p className="m-0">Acta - {a?.numero_acta}</p>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                }
                            </div>
                        </Alert>
                        :

                        amt?.some(a => [3, 7].includes(a?.estado_id)) || aPos?.some(acta => [3, 7].includes(acta?.estado_id))
                            ?
                            <Alert variant="primary" className="d-flex flex-column gap-2 align-items-center">
                                <div className="bg-white d-flex flex-column align-items-center gap-1 p-2 py-4 border rounded shadow-lg w-100">
                                    {/* <b className="text-center">Verificar actas</b> */}

                                    {
                                        aPos?.some(acta => [3, 7].includes(acta?.estado_id)) &&
                                        <div className="mb-4">
                                            <p className="m-0 d-flex justify-content-center align-items-center gap-2">
                                                <DirectionsCarIcon /><b>Misma patente</b>
                                            </p>
                                            {
                                                aPos?.some(acta => acta?.estado_id == 3)
                                                &&
                                                <div className=" w-100 d-flex flex-column align-items-center gap-2 justify-content-center py-2 ">


                                                    <div className="d-flex justify-content-center gap-2 flex-wrap align-items-center">
                                                        <p className="m-0 text-center">Revise todas las actas <BadgeEstados estado_id={3} /> de la misma patente para poder imprimirlas.</p>
                                                        {
                                                            aPos?.filter(acta => acta?.estado_id == 3).map((a, index) => {
                                                                return (
                                                                    <div key={index}
                                                                        className={` px-2 rounded  text-white fw-bold border border-3 ${index == 0 ? 'border-primary bg-secondary' : 'bg-secondary-subtle'}`}
                                                                        style={{ cursor: index == 0 ? "pointer" : "default" }}
                                                                        onClick={() => {
                                                                            if (index == 0) {
                                                                                getActaDetalleHandler({ estado_id: a?.estado_id, id: a?.id })
                                                                            }
                                                                        }}
                                                                    >
                                                                        <p className="m-0">Acta - {a?.numero_acta}</p>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            }

                                            {
                                                aPos?.some(acta => acta?.estado_id == 7)
                                                &&
                                                <div className=" w-100 d-flex flex-column align-items-center gap-2 justify-content-center py-2">
                                                    <p className="m-0 text-center">Complete todas las actas <BadgeEstados estado_id={7} /> del mismo titular para poder imprimirlas.</p>
                                                    <div className="d-flex justify-content-center gap-2 flex-wrap align-items-center">
                                                        {
                                                            aPos?.filter(acta => acta?.estado_id == 7).map((a, index) => {
                                                                return (
                                                                    <div key={index}
                                                                        className={` px-2 rounded  text-white fw-bold border border-3 ${index == 0 ? 'border-primary bg-danger' : 'bg-danger-subtle'}`}
                                                                        style={{ cursor: index == 0 ? "pointer" : "default" }}
                                                                        onClick={() => {
                                                                            if (index == 0) {
                                                                                getActaDetalleHandler({ estado_id: a?.estado_id, id: a?.id })
                                                                            }
                                                                        }}
                                                                    >
                                                                        <p className="m-0">Acta - {a?.numero_acta}</p>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    }
                                    {
                                        amt?.some(acta => [3, 7].includes(acta?.estado_id)) &&
                                        <>
                                            <p className="m-0 d-flex justify-content-center align-items-center gap-2">
                                                <PersonIcon /><b>Mismo titular</b>
                                            </p>
                                            {
                                                amt?.some(acta => acta?.estado_id == 3)
                                                &&
                                                <div className=" w-100 d-flex flex-column align-items-center gap-2 justify-content-center py-2">

                                                    <p className="m-0 text-center">Revise todas las actas <BadgeEstados estado_id={3} /> del mismo titular para poder imprimirlas.</p>
                                                    <div className="d-flex justify-content-center gap-2 flex-wrap align-items-center">
                                                        {
                                                            amt?.filter(acta => acta?.estado_id == 3).map((a, index) => {
                                                                return (
                                                                    <div key={index}
                                                                        className={` px-2 rounded  text-white fw-bold border border-3 ${index == 0 ? 'border-primary bg-secondary' : 'bg-secondary-subtle'}`}
                                                                        style={{ cursor: index == 0 ? "pointer" : "default" }}
                                                                        onClick={() => {
                                                                            if (index == 0) {
                                                                                getActaDetalleHandler({ estado_id: a?.estado_id, id: a?.id })
                                                                            }
                                                                        }}
                                                                    >
                                                                        <p className="m-0">Acta - {a?.numero_acta}</p>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            }

                                            {
                                                amt?.some(acta => acta?.estado_id == 7)
                                                &&
                                                <div className=" w-100 d-flex flex-column align-items-center gap-2 justify-content-center py-2">

                                                    <p className="m-0 text-center">Complete todas las actas <BadgeEstados estado_id={7} /> del mismo titular para poder imprimirlas.</p>
                                                    <div className="d-flex justify-content-center gap-2 flex-wrap align-items-center">
                                                        {
                                                            amt?.filter(acta => acta?.estado_id == 7).map((a, index) => {
                                                                return (
                                                                    <div key={index}
                                                                        className={`bg-danger px-2 rounded  text-white fw-bold `}
                                                                        style={{ cursor: index == 0 ? "pointer" : "default" }}
                                                                        onClick={() => {
                                                                            if (index == 0) {
                                                                                getActaDetalleHandler({ estado_id: a?.estado_id, id: a?.id })
                                                                            }
                                                                        }}
                                                                    >
                                                                        <p className="m-0">Acta - {a?.numero_acta}</p>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            }
                                        </>
                                    }
                                </div>
                            </Alert>
                            :
                            <Alert variant="info" className="d-flex flex-column gap-2 align-items-center">

                                <div className="bg-white d-flex flex-column align-items-center gap-4 p-2 py-4 border rounded shadow-lg w-100">
                                    <div className="d-flex flex-column align-items-center gap-2">
                                        <b className="text-center">Imprimir actas</b>
                                        <div className="d-flex gap-2 justify-content-center align-items-center flex-wrap">
                                            {
                                                actasAImprimir?.map((a, index) => {
                                                    return (
                                                        <div key={index}
                                                            className={`bg-info  px-2 rounded pt-1 text-dark fw-bold `}
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() => { getActaDetalleHandler({ estado_id: a?.estado_id, id: a?.id }) }}>
                                                            <p className="m-0">Acta - {a?.numero_acta}</p>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                    <Button onClick={() => { handlerModal({ modal: "true", modalName: "modal_imprimir_actas2" }) }} className="d-flex gap-2"><PrinterCheckIcon />IMPRIMIR ACTAS</Button>
                                </div>
                            </Alert>
            }
        </div >
    )
}

export default Aprobada